import { Box, Button, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import illustrationSrc from "./illustration_empty_scenarios.svg"

export function ScenariosEmpty({ canManageOptimiser }) {
    // Match the rate-cards / skill-mappings empty states: illustration, then text, then the
    // create button at the bottom. Previously the button sat at the top, which the other
    // Optimiser tabs do not do (FIQ-1579).
    return (
        <Stack data-cy="scenarios-empty" alignItems="center" justifyContent="center" spacing={2} sx={{ py: 4 }}>
            <Box component="img" src={illustrationSrc} sx={{ width: 275, height: 200 }} />
            <Stack spacing={0.5} alignItems="center">
                <Typography variant="h6">No scenarios yet</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420, textAlign: "center" }}>
                    Cost your regimes and create scenarios to compare how different maintenance approaches affect spend
                </Typography>
            </Stack>
            <If value={canManageOptimiser}>
                <Button variant="contained" startIcon={<Iconify icon="mdi:plus" />} onClick={handleCreate}>
                    Create Scenario
                </Button>
            </If>
        </Stack>
    )

    function handleCreate() {
        navigate("/app/optimiser/scenarios/create")
    }
}
